<template>
  <v-container fluid class="ma-0 pa-0">
    <MobileAppBar :title="appbarTitle" :belowVisible="belowVisible"></MobileAppBar>
    <v-col class="ma-0 pa-0 mb-5" cols="12">
      <v-col class="ma-0 pa-2" cols="12" align="right">
        <v-btn
          width="auto"
          height="auto"
          class="ma-0 pa-0 mr-2"
          id="back_clean_btn"
          elevation="0"
          @click="viewDrawer = false"
        >
          <v-img
            max-height="2rem"
            max-width="2rem"
            class="ma-0 pa-0"
            src="@/assets/images/array_btn.png"
          ></v-img>
        </v-btn>
        <v-btn
          width="auto"
          height="auto"
          class="ma-0 pa-0 mr-2"
          id="back_clean_btn"
          elevation="0"
          @click="viewDrawer = true"
        >
          <v-img
            max-height="2rem"
            max-width="2rem"
            class="ma-0 pa-0"
            src="@/assets/images/drawer_btn.png"
          ></v-img>
        </v-btn>
      </v-col>

      <template v-if="viewDrawer == false && streamingUrlLoading == false">
        <v-row>
          <v-col
            v-for="(item, index) in videoStreamList"
            :key="index"
            ref="thumbnailRefArr"
            class="ma-0 pa-4 pt-2 pb-2"
            :cols="getColumnCount()"
            align="center"
            :class="{'non_display': videoStreamList[index] == undefined || streamingUrlLoading }"
          >
            <v-col
              v-if="item.streamAble == true"
              @click="goVideoPlayer(index)"
              class="thumbnail_box ma-0 pa-0"
              cols="12"
              style="cursor: pointer;"
            >
              <v-img
                v-if="!imgLoaders[index].error"
                style="height: 100%; width: 100%;"
                @load="onLoad(index)"
                @error="onError(index)"
                class="ma-0 pa-0"
                :src="item.thumbnail"
              />
              <v-img
                v-else
                style="height: 100%; width: 100%;"
                class="ma-0 pa-0"
                src="@/assets/images/grey_background.png"
              >
              <v-col class="ma-0 pa-0" id="thumbnail_device_status">
                <v-col class="ma-0 pa-0">{{ t('thumbnailError') }}</v-col>
              </v-col>
							</v-img>
              <v-col
                class="ma-0 pa-0 pl-2 ellipsis"
                cols="12"
                id="thumbnail_title_box"
                align="left"
                v-if="streamingUrlLoading == false"
              >
                {{ item.cameraName }}
              </v-col>
              <v-skeleton-loader
                id="img_skeleton"
                width="100%"
                height="100%"
                :boilerplate="false"
                elevation="0"
                dark
                type="image"
                v-if="imgLoaders[index].loading"
                class="ma-0 pa-0"
              ></v-skeleton-loader>
            </v-col>
            <v-col
              v-else
              @click="noUrlGoVideoPlayer(index)"
              class="thumbnail_box ma-0 pa-0"
              cols="12"
              style="cursor: pointer;"
            >
              <v-img
                style="height: 100%; width: 100%;"
                class="ma-0 pa-0"
                src="@/assets/images/grey_background.png"
              />
              <v-col class="ma-0 pa-0" id="thumbnail_device_status">
                <v-col class="ma-0 pa-0">{{ t('offline') }}</v-col>
              </v-col>
              <v-col
                class="ma-0 pa-0 pl-2 ellipsis"
                cols="12"
                id="thumbnail_title_box"
                align="left"
                v-if="streamingUrlLoading == false"
              >
                {{ item.cameraName }}
              </v-col>
            </v-col>
          </v-col>
        </v-row>

        <v-col
          class="ma-0 pa-15"
          cols="12"
          align="center"
          v-if="videoStreamList.length == 0 && streamingUrlLoading == false"
        >
          {{ t('noData') }}
        </v-col>
      </template>

      <template v-else>
        <v-col
          v-for="(item, index) in videoStreamList"
          :key="index"
          ref="thumbnailRefArr"
          class="ma-0 pa-2 pt-0 pb-0"
          cols="12"
          align="center"
          :class="{'non_display': videoStreamList[index] == undefined || streamingUrlLoading }"
        >
          <v-row
            v-if="item.streamAble == true"
            @click="goVideoPlayer(index)"
            class="ma-0 pa-1 thumbnail_box_drawer"
            align="center"
            style="cursor: pointer;"
          >
            <img
              v-if="!imgLoaders[index].error"
              style="height: 3.5rem; width: 3.5rem;"
              @load="onLoad(index)"
              @error="onError(index)"
              class="ma-0 pa-0"
              :src="item.thumbnail"
            />
            <img
              v-else
              style="height: 3.5rem; width: 3.5rem;"
              class="ma-0 pa-0"
              src="@/assets/images/grey_background.png"
            />
            <v-col
              class="ma-0 pa-0 pl-2 ellipsis2"
              cols="10"
              align="left"
              v-if="streamingUrlLoading == false"
            >
              {{ item.cameraName }}
            </v-col>
          </v-row>
          <v-row
            v-else
            @click="noUrlGoVideoPlayer(index)"
            class="ma-0 pa-1 thumbnail_box_drawer"
            align="center"
            style="cursor: pointer;"
          >
            <img
              style="height: 3.5rem; width: 3.5rem;"
              class="ma-0 pa-0"
              src="@/assets/images/grey_background.png"
            />
            <v-col
              class="ma-0 pa-0 pl-2 ellipsis2"
              cols="10"
              align="left"
              v-if="streamingUrlLoading == false"
            >
              {{ item.cameraName }}
            </v-col>
          </v-row>
        </v-col>
      </template>
    </v-col>
  </v-container>
</template>

<script>
import mixin from "@/mixin";
import MobileAppBar from "./components/MobileAppBar.vue";
import rtcViewer from '@/api/webrtc';
import { VideoErrorStatus } from '@/constants';

export default {
  components: {
    MobileAppBar
  },
  mixins: [mixin.common],
  data: () => ({
    role: "",
    appbarTitle: "",
    streamList: [],
    videoStreamList: [],
    streamingUrlLoading: false,
    imgLoaders: [],
    deviceErrorStr: "",
    tempList: [],
    viewDrawer: false,
    belowVisible: true,
    userDetailData: {},
    isPortraitCols: 12
  }),
  watch: {
    videoStreamList: {
      handler(newList) {
        // videoStreamList가 변경될 때마다 imgLoaders 배열을 재설정합니다.
        this.imgLoaders = newList.map(() => ({ loading: true, error: false }));
      },
      immediate: true
    }
  },
  created() {
    for (var i = 0; i < 99; i++) {
      this.imgLoaders.push({ loading: true, error: false });
    }
    this.role = this.roleCheck(this.$store.getters.getRole);
    if (this.role == "private" || this.role == "branch") {
      this.belowVisible = false;
    } else {
      this.belowVisible = true;
    }
    this.onResize();
    this.isPortraitCols = this.checkPortrait();
  },
  mounted() {
    if (this.role == "private" || this.role == "branch") {
      this.getCameraList();
      this.userDetailData = this.$store.getters.getUserDetail;
      this.appbarTitle = this.userDetailData.unisCustomerName;
      this.checkCameraAuthResult();
    } else {
      // main, head
      let unisCustomerCd = this.$route.query.unisCustomerCd;
      this.fetchStoreDetail(unisCustomerCd);
      this.checkCameraAuthResult();
    }
    let portrait = window.matchMedia("(orientation: portrait)");
    portrait.addEventListener("change", this.onResize);
    // 페이지 로드 시 스크롤을 제일 위로 이동
    window.scrollTo(0, 0);
    this.$store.commit('player/SET_PLAYER_ALL_VALUE_DEFAULT');
    setTimeout(() => rtcViewer.removeRTCRemnants(), 1000);
  },
  beforeDestroy() {
    if (typeof window === "undefined") return;
    let portrait = window.matchMedia("(orientation: portrait)");
    portrait.removeEventListener("change", this.onResize);
  },
  methods: {
    onResize() {
      console.log("resize");
      this.$store.state.isPortrait = window.innerHeight > window.innerWidth;
      this.isPortraitCols = this.checkPortrait();
    },
    checkPortrait() {
      if (this.$store.state.isMobile) {
        console.log("isPortrait- ", this.$store.state.isPortrait);
        if (this.$store.state.isPortrait) return 12;
        else return 6;
      } else {
        // pc
        console.log("pc");
        return 6;
      }
    },
    fetchStoreDetail(unisCustomerCd) {
      if (unisCustomerCd == undefined) return;
      this.streamingUrlLoading = true;
      this.imgLoaders = [];
      for (var i = 0; i < 99; i++) {
        this.imgLoaders.push({ loading: true, error: false });
      }
      let params = {};
      this.networkController.getStoreDetail(params, unisCustomerCd).then(async (res) => {
        console.log("%cStore Detail\n", "color:#008DD0;", res.data[0]);
        console.log("%cDashboard Camera List\n", "color:#008DD0;", res.data[0].storeCameras);
        this.streamList = res.data[0].storeCameras;
        this.appbarTitle = res.data[0].customerName;
        if (this.streamList.length != 0) {
          this.videoStreamList = [];
          this.tempList = [];
          this.streamList.forEach((item, index) => {
            if (item.isOnline && item.isUas === false) {
              let data = item;
              data.streamAble = true;
              this.tempList.push(data);
              console.log(data);
            }
            if (index == this.streamList.length - 1) {
              setTimeout(() => {
                this.listSorting();
              }, 250);
            }
          });
        } else {
          this.streamingUrlLoading = false;
        }
      }).catch(error => {
        console.error(error);
      });
    },
    getCameraList() {
      this.streamingUrlLoading = true;
      this.imgLoaders = [];
      for (var i = 0; i < 99; i++) {
        this.imgLoaders.push({ loading: true, error: false });
      }
      let params = {};
      this.networkController.getDashboardCameraList(params).then(async (res) => {
        console.log("%cDashboard Camera List\n", "color:#008DD0;", res.data);
        this.streamList = res.data;
        if (res.data.length != 0) {
          this.videoStreamList = [];
          this.tempList = [];
          this.streamList.forEach((item, index) => {
            if (item.isOnline && item.isUas === false) {
              let data = item;
              data.streamAble = true;
              this.tempList.push(data);
            }
            if (index == this.streamList.length - 1) {
              setTimeout(() => {
                this.listSorting();
              }, 250);
            }
          });
        } else {
          this.streamingUrlLoading = false;
        }
      }).catch(error => {
        this.streamingUrlLoading = false;
      });
    },
    listSorting() {
      this.videoStreamList = this.tempList.sort(function (a, b) {
        return (a.cameraName < b.cameraName) ? -1 : ((a.cameraName > b.cameraName) ? 1 : 0);
      });
      console.log(this.videoStreamList, this.tempList);
      this.streamingUrlLoading = false;
    },
    onLoad(index) {
      this.imgLoaders.splice(index, 1, { loading: false, error: false });
    },
    onError(index) {
      this.imgLoaders.splice(index, 1, { loading: false, error: true });
    },
    async goVideoPlayer(index) {
      this.$vloading.show();
      this.$store.commit("setPlayerFromWhere", { from: "dashboard", name: "dashboard" });
      this.$store.commit("setMobileCameraName", this.videoStreamList[index].cameraName);
      await this.$store.commit("setStreamInfo", this.videoStreamList[index]);
      this.$vloading.hide();
      this.replaceRoute("/video-player", {});
    },
    async noUrlGoVideoPlayer(index) {
      this.$store.commit("setPlayerFromWhere", { from: "dashboard", name: "dashboard" });
      this.$store.commit("setMobileCameraName", this.videoStreamList[index].cameraName);
      await this.$store.commit("setVideoStreamingUrl", "");
      await this.$store.commit("setStreamInfo", this.videoStreamList[index]);
      this.replaceRoute("/video-player", {});
    },
    getColumnCount() {
      const { lg, sm, md, xl, xs } = this.$vuetify.breakpoint;
      return lg ? 2 : sm ? 4 : md ? 6 : 12;
    }
  }
};
</script>

<style lang="scss" scoped>
.thumbnail_box {
  position: relative;
}

.thumbnail_box_length {
  height: 25rem !important;
}
.thumbnail_box_drawer {
  border-top: 1px solid rgb(65, 65, 65);
}
#thumbnail_title_box {
  position: absolute;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.75);
  color: #bebebe;
  font-size: 0.8rem;
}
#thumbnail_device_status {
  color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -55%);
}
.non_display {
  display: none;
}
#img_skeleton {
  position: absolute;
  top: 0;
}
</style>
